import { TimeSlot } from "@clipboard-health/contract-worker-app-bff";
import { Card } from "@clipboard-health/ui-components";
import { CardActionArea } from "@mui/material";
import { InternalLink } from "@src/appV2/lib";
import { useGetQualificationDisplayLabels } from "@src/appV2/Qualifications/api/useGetQualificationDisplayLabels";
import { DEFAULT_TIMEZONE } from "@src/appV2/Shifts/Shift/constants";
import { shiftPeriodToTimeSlot } from "@src/appV2/Shifts/Shift/types";
import { generatePath } from "react-router-dom";

import { getFormattedShiftPayBreakdown } from "../../Shift/getFormattedShiftPayBreakdown";
import { WorkerShiftCard } from "../../Shift/WorkerShift/Card";
import { BOOKING_REQUEST_DETAILS_FULL_PATH } from "../path";
import {
  type BookingRequest,
  type BookingRequestIncludedOffer,
  type BookingRequestIncludedShift,
  type BookingRequestIncludedWorkplace,
} from "./types";

interface BookingRequestShiftCardProps {
  shift: BookingRequestIncludedShift;
  bookingRequest: BookingRequest;
  workplace: BookingRequestIncludedWorkplace;
  offer: BookingRequestIncludedOffer;
}

export function BookingRequestShiftCard(props: BookingRequestShiftCardProps) {
  const { shift, bookingRequest, workplace, offer } = props;

  const payBreakdown = getFormattedShiftPayBreakdown(
    offer.attributes.pay.value,
    shift.attributes.time * offer.attributes.pay.value,
    shift.attributes.time * offer.attributes.pay.value
  );
  const href = generatePath(BOOKING_REQUEST_DETAILS_FULL_PATH, {
    bookingRequestId: bookingRequest.id,
  });

  const { data: qualificationDisplayLabels } = useGetQualificationDisplayLabels([
    shift.attributes.qualification,
  ]);
  const qualificationText = qualificationDisplayLabels[0];

  return (
    <Card outlined variant="quaternary">
      <CardActionArea component={InternalLink} to={href}>
        <WorkerShiftCard
          href={href}
          workplaceId={workplace.id}
          workplaceName={workplace.attributes.name}
          workplaceTimezone={workplace.attributes.tmz ?? DEFAULT_TIMEZONE}
          workplaceRequiresLunchBreak={false}
          shiftTimeSlot={shiftPeriodToTimeSlot[shift.attributes.name] ?? TimeSlot.AM}
          shiftStart={shift.attributes.start}
          shiftEnd={shift.attributes.end}
          shiftQualificationName={qualificationText}
          shiftHourlyPay={payBreakdown?.hourlyPay}
          shiftTotalPay={payBreakdown?.totalPay}
        />
      </CardActionArea>
    </Card>
  );
}
